import { lazy } from 'react';
import { shopIcon, subGroupsIcon } from '@tools/ui/assets';
import type { AppRouter } from '@tools/ui/types';
import { UnmatchTasks } from '../pages/unmatch-tasks/UnmatchTasks';
import { unmatchTasksRoutes } from './routes.unmatch-tasks';
import { verificationTasksRoutes } from './routes.verification-tasks';

export const BUSY_BASE_PATH = '/busy';
export const BUSINESS_VERIFICATION_BASE_PATH = `${BUSY_BASE_PATH}/business-verification`;
export const UNMATCH_TASKS_BASE_PATH = `${BUSY_BASE_PATH}/business-unmatch`;
export const UNMATCH_TASKS_REVIEW_PATH = `${BUSY_BASE_PATH}/business-unmatch/tasks`;

const VerificationTasks = lazy(
  () =>
    import(
      /* webpackChunkName: "BusyRoutes" */ '../pages/verification-tasks/VerificationTasks'
    )
);

const VerificationGroupTasks = lazy(
  () =>
    import(
      /* webpackChunkName: "BusyRoutes" */ '../pages/verification-tasks/group-tasks/VerificationGroupTasks'
    )
);

const UnmatchTasksReviewScreen = lazy(
  () =>
    import(
      /* webpackChunkName: "BusyRoutes" */ '../pages/unmatch-tasks/unmatch-tasks-review-screen/UnmatchTasksReviewScreen'
    )
);

export const busyRoutes: AppRouter = {
  modules: [
    {
      redirectFrom: [BUSY_BASE_PATH, `${BUSY_BASE_PATH}/*`]
    },
    {
      name: 'Business verification',
      path: `${BUSINESS_VERIFICATION_BASE_PATH}/inbox`,
      component: VerificationTasks,
      exact: false,
      icon: shopIcon,
      pages: verificationTasksRoutes
    },
    {
      name: 'Business verification tasks',
      path: `${BUSINESS_VERIFICATION_BASE_PATH}/tasks/:taskId`,
      component: VerificationGroupTasks,
      hideFromMenu: true,
      exact: true,
      pages: []
    },
    {
      name: 'Business unmatch',
      path: `${UNMATCH_TASKS_BASE_PATH}/inbox`,
      component: UnmatchTasks,
      exact: false,
      icon: subGroupsIcon,
      pages: unmatchTasksRoutes
    },
    {
      name: 'Business unmatch tasks review screen',
      path: UNMATCH_TASKS_REVIEW_PATH,
      component: UnmatchTasksReviewScreen,
      hideFromMenu: true,
      exact: true,
      pages: []
    }
  ]
};
